"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const NewRelic_1 = __importDefault(require("../NewRelic/NewRelic"));
const KevelAnalytics_1 = __importDefault(require("../KevelAnalytics/KevelAnalytics"));
const BrandBanner_1 = __importDefault(require("../BrandBanner/BrandBanner"));
const HomeCategoryBanner_1 = __importDefault(require("../HomeCategoryBanner/HomeCategoryBanner"));
const NavFlyoutBanner_1 = __importDefault(require("../NavFlyoutBanner/NavFlyoutBanner"));
const OrderConfirmationBanner_1 = __importDefault(require("../OrderConfirmationBanner/OrderConfirmationBanner"));
const BrandAZBanner_1 = __importDefault(require("../BrandAZBanner/BrandAZBanner"));
const KevelSearchBanner_1 = __importDefault(require("../KevelSearchBanner/KevelSearchBanner"));
const KevelBanner = (props) => {
    let banner = null;
    let browserCacheEnabled = false;
    if (props.esiType === "brand") {
        banner = react_1.default.createElement(BrandBanner_1.default, Object.assign({}, props));
    }
    else if (props.esiType === "category" || props.esiType === "home") {
        banner = (react_1.default.createElement(HomeCategoryBanner_1.default, { data: props, testId: props.esiType === "category" ? "category" : "home" }));
    }
    else if (props.esiType === "navFlyout") {
        banner = react_1.default.createElement(NavFlyoutBanner_1.default, Object.assign({}, props));
        browserCacheEnabled = true; // NavFlyout is eligible for browser cache detection
    }
    else if (props.esiType === "broad") {
        banner = (react_1.default.createElement(OrderConfirmationBanner_1.default, Object.assign({}, props)));
    }
    else if (props.esiType === "brandAZLarge") {
        banner = react_1.default.createElement(BrandAZBanner_1.default, Object.assign({}, props));
    }
    else if (props.esiType === "search-v2") {
        banner = react_1.default.createElement(KevelSearchBanner_1.default, Object.assign({}, props));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        banner,
        react_1.default.createElement(KevelAnalytics_1.default, { events: [
                {
                    adId: props.associatedAdvertId,
                    type: "banner",
                    clickUrl: props.clickUrl,
                    impressionUrl: props.impressionUrl,
                },
            ], browserCacheEnabled: browserCacheEnabled }),
        react_1.default.createElement(NewRelic_1.default, { adId: props.associatedAdvertId, esiType: props.esiType })));
};
exports.default = KevelBanner;
